import { render, staticRenderFns } from "./LmWait.vue?vue&type=template&id=765e4a31&"
import script from "./LmWait.vue?vue&type=script&lang=js&"
export * from "./LmWait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports